import { get } from 'lodash';
import * as React from 'react';
import { reduxForm } from 'redux-form';
import { compose } from 'recompose';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { RemoteAutoCompleteField, RemoteAutoComplete } from '@components/form';
import { required } from '@utils/validators';

const enhance = compose<any, any>(reduxForm({ form: 'dayplanForm' }));

const View: React.SFC<any> = ({ handleSubmit, dayPlan, isCreating, removeDayPlan }) => (
  <>
    {!isCreating && (
      <div>
        Původní denní plán: {get(dayPlan, 'label')} - {get(dayPlan, 'description')}
      </div>
    )}
    <form onSubmit={handleSubmit}>
      <Grid fluid={true}>
        <Row>
          <Col xs={12} md={5}>
            <RemoteAutoCompleteField
              id="type"
              caching={true}
              name="dayPlan"
              label="Nový denní plán *"
              fullWidth={true}
              component={RemoteAutoComplete}
              url="/metropolis/api/hr/workplan/calendar/day"
              labelFunction={o => (o ? `${get(o, 'label')} - ${get(o, 'description')}` : ``)}
              valueFunction={o => o}
              validate={[required]}
              arrowstyle={{
                color: '#e1e0e1',
                position: 'absolute',
                right: 0,
                top: 32
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Button label="Uložit" type="submit" primary={true} style={{ margin: '15px 15px 0 0' }} />
            {!isCreating && (
              <Button
                label="Smazat"
                style={{ margin: '15px 15px 0 0' }}
                onClick={() => removeDayPlan(get(dayPlan, 'id'))}
              />
            )}
          </Col>
        </Row>
      </Grid>
    </form>
  </>
);

export default enhance(View);



// WEBPACK FOOTER //
// ./src/modules/hr-shift-cycles/DayplanForm.tsx